import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/** Redirige rutas legacy al listado con el drawer de curso abierto. */
export const CourseEdit = ({ isCreating }) => {
    const navigate = useNavigate();
    const { idCourse } = useParams();

    useEffect(() => {
        navigate('/cursos', {
            replace: true,
            state: {
                openCourseDrawer: isCreating ? 'create' : 'edit',
                courseId: idCourse,
            },
        });
    }, [isCreating, idCourse, navigate]);

    return null;
};
